function Settings() {
  return (
    <div className="p-4">
      <p className="text-gray-600">Settings page content will be added here.</p>
    </div>
  );
}

export default Settings;
